import styled, { css } from "styled-components";
import { ReactComponent as User } from "../../assets/icons/user.svg";
import { ReactComponent as Calendar } from "../../assets/icons/calendar.svg";

export const Container = styled.div`
  min-width: 345px;
  max-width: 500px;
  display: flex;
  flex: 1;
  flex-direction: column;
  flex-wrap: wrap;
  margin: 20px 15px;
  box-shadow: 0px 10px 50px rgba(13, 38, 59, 0.1);
  transition: 0.2s ease-in-out;
  :hover {
    transform: scale(1.05);
    cursor: pointer;
  }
`;
const Icon = css`
  display: flex;
  align-items: center;
  padding: 0;
`;
const Info = css`
  color: var(--common-blue-color);
  font-size: var(--nav-item-size);
  text-transform: uppercase;
  line-height: 17px;
  text-decoration: underline;
  font-style: normal;
  font-weight: 600;
  margin-top: 15px;
  :hover {
    cursor: pointer;
    color: var(--blue-hover-button-color);
  }
`;
const Img = css`
  background: cover;
  width: 100%;
  position: relative;
`;

export const Wrapper = styled.div`
  padding: ${({ main }) => main === "true" && "26px 26px 30px 20px"};
  background: ${({ main }) => main === "true" && "var(--default-text-color)"};
  ${({ icons }) => icons === "true" && Icon};
  ${({ info }) => info === "true" && Info};
  ${({ img }) => img === "true" && Img};
  border-radius: ${({ main }) => main === "true" && "3px"};
`;
Wrapper.Image = styled.img`
  width: 100%;
  height: 220px;
  cursor: pointer;
  transition: 0.3s ease-in-out;
  opacity: 0.9;
  :hover {
    opacity: 1;
  }
  border-radius: 3px;
`;
const Type = css`
  position: absolute;
  top: 1px;
  border-radius: 3px;
  background-color: var(--common-blue-color);
  color: var(--default-text-color);
  font-size: var(--items-sale-size);
  line-height: 13px;
  font-style: normal;
  text-transform: uppercase;
  padding: 5px 12px;
  top: 20px;
  left: 20px;
  letter-spacing: 1px;
  font-weight: 600;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
`;
Wrapper.Title = styled.div`
  font-style: normal;
  font-weight: ${({ title }) => (title ? "600" : "normal")};
  margin: ${({ titleDesc }) => titleDesc && "14px 0 9px 0"};
  font-size: var(--font-size-primary);
  line-height: 28px;
  color: ${({ desc }) =>
    desc ? "var(--icon-hover-color)" : "var(--common-dark-color)"};
  ${({ type }) => type === "true" && Type};
`;

export const Icons = styled.div``;
Icons.User = styled(User)`
  width: 15px;
  height: 15px;
  & path {
    fill: gray;
  }
  :active {
    transform: scale(1.1);
  }
  margin-right: 13px;
  cursor: pointer;
`;
Icons.Calendar = styled(Calendar)`
  cursor: pointer;
  width: 15px;
  height: 15px;
  margin: 0 10px 0 30px;
  :active {
    transform: scale(1.1);
  }
`;
